export default __webpack_public_path__ + "static/media/hn.41a5eab2.svg";